/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Fresh_Finch_NourishInputs */

const fr_true_fresh_finch_nourish = /** @type {(inputs: True_Fresh_Finch_NourishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de la salle`)
};

/**

* @param {True_Fresh_Finch_NourishInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const true_fresh_finch_nourish = /** @type {((inputs?: True_Fresh_Finch_NourishInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Fresh_Finch_NourishInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_true_fresh_finch_nourish(inputs)
});